import { useState, useEffect, useRef } from "react";
import {
  Grid,
  Dialog,
  Box,
  Button,
  Typography,
  IconButton,
  DialogContent,
  DialogTitle,
  DialogActions,
  TextField,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import icon_comfri from "../../../../Image/icon_comfri.png";
import signsuccess from "../../../../Image/signsuccess.png";
import { APIEndpointWeb, GetLocalStorageOrganization, webapi } from "../../../../client/web";
import Swal from "sweetalert2";



interface ConfirmAndSuccessDialogProps {
  formDatamockPriority3: any
  openConfirmDialog: boolean
  setOpenConfirmDialog: (value: boolean) => void;
  openSuccessDialog: boolean
  setOpenSuccessDialog: (value: boolean) => void;
  setLoading: (value: boolean) => void;
  accessToken: string

}

const ConfirmAndSuccessDialog: React.FC<ConfirmAndSuccessDialogProps> = ({ openConfirmDialog, setOpenConfirmDialog, openSuccessDialog, setOpenSuccessDialog, formDatamockPriority3, setLoading, accessToken }) => {
  // const [openConfirmDialog, setOpenConfirmDialog] = useState(false); // 🔹 Dialog 3: ยืนยันการเซ็น
  // const [openSuccessDialog, setOpenSuccessDialog] = useState(false); // 🔹 Dialog 4: เซ็นสำเร็จ
  const handleCloseConfirmDialog = () => setOpenConfirmDialog(false);
  const handleCloseSuccessDialog = () => setOpenSuccessDialog(false);
  const [localStorageOrganization, setLocalStorageOrganization] = useState<any>(null);

  // const handleSave = () => {
  //   setOpenConfirmDialog(true);
  //   // onClose();
  // };

  useEffect(() => {
    let glso = GetLocalStorageOrganization()
    setLocalStorageOrganization(glso)
  }, []);

  const handleConfirmSave = async () => {
    try {
      setLoading(true)
      setOpenConfirmDialog(false)

      //  console.log("formDatamockPriority3", formDatamockPriority3)
      var { data } = await webapi.post(`${APIEndpointWeb.MultiSignSslPdfCadUpdateDocument}`, formDatamockPriority3,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        });

      setOpenSuccessDialog(true)

      setTimeout(() => {
        setOpenSuccessDialog(false); // ปิด Dialog 4 หลังจาก 2 วินาที
        window.location.replace("/admin-page-document")
      }, 3000); // 4 วินาทีจากจุดเริ่มต้น
      setLoading(false)

    } catch (error: any) {
      setLoading(false)
      console.log(error)
      try {
        Swal.fire({
          title: error.response.data.status_result.status_message_th,
          icon: "error",
        });
      } catch (error) {
        Swal.fire({
          title: "บันทึกการแก้ไขเอกสารไม่สำเร็จ",
          icon: "error",
        });
      }
    } finally {
      setLoading(false)
    }
  }




  return (
    <>
      {/* ✅ Dialog : ยืนยันการเซ็นเอกสาร */}
      <Dialog
        // style={{display:'none'}}
        open={openConfirmDialog}
        onClose={(event, reason) => {
          if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
            handleCloseSuccessDialog();
          }
        }}
        fullWidth
        maxWidth="xs"
        PaperProps={{
          sx: {
            bgcolor: "#FFFFFF",
            borderRadius: "20px",
            boxShadow: 3,
            p: 1,
            width: "450px",
          },
        }}
      >
        <IconButton
          onClick={handleCloseConfirmDialog}
          sx={{ position: "absolute", top: 8, right: 8 }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent>
          <Grid
            container
            spacing={2}
            justifyContent="center"
            alignItems="center"
          >
            <Grid item xs={12} display="flex" justifyContent="center">
              <img
                src={icon_comfri}
                alt="รูปภาพ"
                style={{
                  width: 170,
                  height: "auto",
                  marginBottom: 18,
                  marginTop: 16
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography
                variant="body1"
                sx={{
                  mt: -2,
                  fontFamily: "Sarabun, sans-serif",
                  textAlign: "center",
                  color: "#333333",
                  fontSize: "16px",
                  fontWeight: "bold",
                }}
              >
                ต้องการยืนยันการแก้ไข
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography
                variant="body1"
                sx={{
                  mt: -1,
                  fontFamily: "Sarabun, sans-serif",
                  textAlign: "center",
                  color: "#636363",
                  fontSize: "14px",
                }}
              >
                คุณต้องการยืนยันแก้ไขใบสมัครเข้าร่วมโครงการ
                และเอกสารข้อตกลงการแบ่งปันข้อมูลส่วนบุคคล (DSA) สังกัด{localStorageOrganization?.hname_th} ใช่หรือไม่
              </Typography>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Grid container spacing={2} justifyContent="center" mb={2}>
            <Grid item>
              <Button
                onClick={handleCloseConfirmDialog}
                variant="outlined"
                color="error"
                sx={{
                  width: "120px",
                  height: "40px",
                  borderRadius: "20px",
                }}
              >
                ยกเลิก
              </Button>
            </Grid>
            <Grid item>
              <Button
                onClick={handleConfirmSave}
                variant="contained"
                sx={{
                  width: "120px",
                  height: "40px",
                  backgroundColor: "#0288D1",
                  borderRadius: "20px",
                  "&:hover": { backgroundColor: "#0288D1" },
                }}
              >
                ยืนยัน
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      {/* ✅ Dialog : ยืนยันการเซ็นเอกสารสำเร็จ */}
      {/* {String(openSuccessDialog)} */}
      <Dialog
        // open={openSuccessDialog}
        open={openSuccessDialog}
        onClose={(event, reason) => {
          if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
            handleCloseSuccessDialog();
          }
        }}
        fullWidth
        maxWidth="xs"
        PaperProps={{
          sx: {
            bgcolor: "#FFFFFF",
            borderRadius: "20px",
            boxShadow: 3,
            p: 2,
            width: "400px",
          },
        }}
      >
        <IconButton
          onClick={handleCloseSuccessDialog}
          sx={{ position: "absolute", top: 8, right: 8 }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent>
          <Grid
            container
            spacing={2}
            justifyContent="center"
            alignItems="center"
          >
            <Grid item xs={12} display="flex" justifyContent="center">
              <img
                src={signsuccess}
                alt="รูปภาพ"
                style={{
                  width: 280,
                  height: "auto",
                  marginBottom: "20px",
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography
                sx={{
                  textAlign: "center",
                  color: "#333333",
                  fontSize: "16px",
                  fontWeight: "bold",
                }}
              >
                ยืนยันการแก้ไขเอกสารสำเร็จ
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography
                sx={{
                  mt: -1,
                  textAlign: "center",
                  color: "#636363",
                  fontSize: "14px",
                }}
              >
                ทำการแก้ไขเอกสาร เรียบร้อยแล้ว
              </Typography>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ConfirmAndSuccessDialog;
